import React from 'react';
import PropTypes from 'prop-types';
import { Star } from 'lucide-react';

const RatingStars = ({ rating, totalReviews, containerClass = '' }) => {
  const stars = [...Array(5)].map((_, i) => {
    const integerPart = Math.floor(rating);
    const decimalPart = rating - integerPart;
    const fillPercentage = i < integerPart ? 100 : i === integerPart ? decimalPart * 100 : 0;

    return (
      <div key={i} className="relative w-4 h-4" aria-hidden="true">
        <Star className="absolute w-4 h-4 stroke-gray-300 fill-transparent" />
        <div
          className="absolute inset-0 overflow-hidden"
          style={{ width: `${fillPercentage}%` }}
        >
          <Star className="w-4 h-4 fill-yellow-400 stroke-yellow-400" />
        </div>
      </div>
    );
  });

  return (
    <div className={`flex items-center gap-1 ${containerClass}`}>
      {stars}
      {totalReviews !== undefined && (
        <span className="text-gray-500 ml-1 text-xs">({totalReviews})</span>
      )}
    </div>
  );
};

RatingStars.propTypes = {
  rating: PropTypes.number.isRequired,
  totalReviews: PropTypes.number,
  containerClass: PropTypes.string,
};

export default React.memo(RatingStars);
